<template>
    <div class="topbar-container">
        <div class="line"></div>
        <div class="text1">
            <div class="title1 bh bstart fz_28">
                <div class="b1 c_666">打款状态</div>
                <div class="c_warning">{{item.withdrawStatusStr}}</div>
            </div>
            <div class="title2 bh bstart fz_28">
                <div class="b1 c_666">支付车主币(个)</div>
                <div class="c_black">{{item.withdrawPoint}}</div>
            </div>
            <div class="title3 bh bstart fz_28" v-show="item.withdrawStatusStr === '提现中'">
                <div class="b1 c_666">预计入账金额(元)</div>
                <div class="c_black">{{moneyNum}}</div>
            </div>
             <div class="title3 bh bstart fz_28" v-show="item.withdrawStatusStr === '交易失败'">
                <div class="b1 c_666">退回车主币(个)</div>
                <div class="c_black">{{item.withdrawPoint}}</div>
            </div>
             <div class="title3 bh bstart fz_28" v-show="item.withdrawStatusStr === '交易成功'">
                <div class="b1 c_666">实际入账金额(元)</div>
                <div class="c_black">{{moneyNum}}</div>
            </div>
        </div>
        <div class="line"></div>
        <div class="text2">
            <div class="title1 bh bstart fz_28">
                <div class="b1 c_666">交易类型</div>
                <div class="c_black">{{item.orderTypeStr}}</div>
            </div>
            <div class="title2 bh bstart fz_28">
                <div class="b1 c_666">交易时间</div>
                <div class="c_black">{{item.withdrawTime}}</div>
            </div>
            <div class="title3 bh bstart fz_28">
                <div class="b1 c_666">交易单号</div>
                <div class="c_black">{{item.orderCode}}</div>
            </div>
            <div class="title4 bh bstart fz_28">
                <div class="b1 c_666">提现方式</div>
                <div class="c_black">{{item.bankName}}({{bankNum}})</div>
            </div>
            <div class="title5 bh bstart fz_28" v-show="isVerification && item.withdrawStatusStr === '交易失败'">
                <div class="c_666">失败原因</div>
                <!-- <div class="c_black sbreakword align-content">{{item.errorMsg}}</div> -->
                <div class="b1 tr breakword">
                    <span class="align-content">{{item.errorMsg}}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { user } from "@/mixin/user";
import { list } from "@/mixin/list";
import { routeCache } from "@/mixin/cache";
export default {
    mixins: [user, list, routeCache],
    name: "UserMoneyInfo",
    data() {
        return {
            item: {},
            moneyNum: "",
            // 卡号后四位
            bankNum: ""
        };
    },
    computed: {
        isVerification() {
            return this.item.errorMsg;
        }
    },
    methods: {
        userLoginend() {
            const me = this,
                data = me.getCache();
            me.item = data;
            console.log(me.item);
            // 转换为两位小数
            this.moneyNum = me.item.withdrawAmount.toFixed(2);
            // 截取后银行卡四位
            this.bankNum = me.item.bankCardNumber.substring(
                me.item.bankCardNumber.length - 4
            );
        }
    }
};
</script>

<style scoped lang="scss">
.topbar-container {
    background-color: #f1f2f3;
}
.text1 {
    background-color: #ffffff;
    padding: 0 30px;
    .title1 {
        padding: 39px 0 38px 0;
    }
    .title2 {
        padding-bottom: 40px;
    }
    .title3 {
        padding-bottom: 40px;
    }
}

.text2 {
    background-color: #ffffff;
    padding: 0 30px;
    .title1 {
        padding: 39px 0 38px 0;
    }
    .title2 {
        padding-bottom: 40px;
    }
    .title3 {
        padding-bottom: 36px;
    }
    .title4 {
        padding-bottom: 40px;
    }
    .title5 {
        padding-bottom: 40px;
        .breakword {
            margin-left: 40px;
        }
    }
}
</style>